import { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Facebook, Twitter, Instagram, ShoppingCart, Mail, ArrowRight } from 'lucide-react';
import { productos } from '../data/db/Products';
import { Star } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import {handleBuy} from '../functions/VerifyAddToCart'
import { Terms } from '../components/Terms';







const ProductDetail = (): JSX.Element => {
  const { id } = useParams<{ id: string }>();
  const product = productos.find((p) => p.id === parseInt(id || ''));

  if (!product) {
    return <div>Producto no encontrado</div>;
  }

  const [selectedImage, setSelectedImage] = useState<number>(0);
  const [quantity, setQuantity] = useState<number>(1);
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const navigate = useNavigate()



  const volverAPaginaAnterior = () => {
    // Recuperar el estado previo de la página desde localStorage
    const prevPageState = localStorage.getItem('prevPageState');
  
    if (prevPageState) {
      const { currentPage } = JSON.parse(prevPageState);
  
      // Redirigir a la página de productos con el estado anterior
      navigate(`/products?page=${currentPage}`);
      console.log(currentPage)
    } else {
      // Si no hay estado guardado, redirigir a la página principal de productos
      navigate('/productos');
    }
  };
  
  
  return (
    <div
      
      className="min-h-screen bg-gray-50 py-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Migas de pan */}
        <nav
          
          className="mb-8"
        >
          <ol className="flex space-x-2 text-sm text-dark">
            <li>
              <Link to="/products" className="hover:text-primary transition-colors">
                Todos los productos
              </Link>
            </li>
            
            <li>/</li>
            <li className="text-dark text-1xl truncate max-w-[200px]">{product.titulo}</li>
          </ol>
        </nav>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Galería de imágenes */}
          <div
           
            className="space-y-6"
          >
            <div className="aspect-w-1 aspect-h-1 bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow duration-300">
              
                <img
                  key={selectedImage}
                  src={product.imagenes[selectedImage]}
                  alt={product.titulo}
                  className="w-full h-[28rem] object-contain cursor-zoom-in"
                 
                />
            </div>

            <div className="grid grid-cols-4 gap-3">
              {product.imagenes.map((img, index) => (
                <div
                  key={index}
                  
                  onClick={() => setSelectedImage(index)}
                  className={`cursor-pointer border-2 rounded-xl overflow-hidden transition-all ${
                    selectedImage === index
                      ? 'border-primary shadow-md'
                      : 'border-gray-200 hover:border-primary/50'
                  }`}
                >
                  <img
                    src={img}
                    alt={`Vista ${index + 1} de ${product.titulo}`}
                    className="w-full h-24 object-cover"
                  />
                </div>
              ))}
            </div>
          </div>

    


          {/* Detalles del producto */}
          <div
            
            className="space-y-6"
          >
            <h1 className="text-2xl font-bold font-poppins text-dark tracking-tight">
              {product.titulo}
            </h1>

            <button 
  onClick={volverAPaginaAnterior} 
  className="px-6 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-lg shadow-md transition duration-300 ease-in-out transform hover:scale-105"
>
  ← Volver a productos
</button>

            <div className="flex items-baseline gap-3">
  <span className="text-3xl font-bold text-primary bg-primary/10 px-4 py-2 rounded-xl">
    RD$ {product.precio?.toFixed(2)}
  </span>
  <span className="text-sm text-dark">Impuestos incluidos</span>
</div>




<div className="pt-6 border-t border-gray-200">
  <h2 className="text-2xl font-bold font-poppins mb-4 text-dark">
    Descripción del producto
  </h2>
  <p className="text-dark leading-relaxed  font-poppins text-lg">{product.descripcion ?? "No disponible"}</p>
</div>

      <div className="space-y-3 bg-gray-50 p-4 rounded-xl">
        <p className="flex gap-2">
          <span className="font-semibold text-dark min-w-[80px]">Material:</span>
          <span className="text-dark">{product.material ?? "No especificado"}</span>
        </p>
        <p className="flex gap-2">
          <span className="font-semibold text-dark min-w-[80px]">ProducId:</span>
          <span className="text-dark">{product.product_cloud_Id ?? "No especificado"}</span>
        </p>
        <p className="flex gap-2">
          <span className="font-semibold text-dark min-w-[80px]">Categoria:</span>
          <span className="text-dark">{product.categoria ?? "No especificado"}</span>
        </p>
        
        <p className="flex gap-2">
        <span className="font-semibold text-dark min-w-[80px]">Rating:</span>
        <span className="flex items-center text-dark">
          {/* Mostrar las estrellas llenas */}
          {Array.from({ length: 5 }, (_, index) => (
            <Star
              key={index}
              className={`w-5 h-5 ${index < product.rating ? "text-yellow-500" : "text-gray-300"}`}
            />
          ))}
          {/* Mostrar el valor del rating */}
          <span className="ml-2">{product.rating ?? "No especificado"}</span>
        </span>
      </p>
        <p className="flex gap-2">
        <span className="font-semibold text-dark min-w-[80px]">Talla:</span>
        <span className="text-dark">
          {Array.isArray(product.talla) ? product.talla.join(", ") : "No disponible"}
        </span>
      </p>

<p className="flex gap-2">
  <span className="font-semibold text-dark min-w-[80px]">Color:</span>
  <span className="text-dark">
    {Array.isArray(product.color) ? product.color.join(", ") : product.color ?? "No disponible"}
  </span>
</p>

  <p
    className={`text-sm font-medium ${product.stock > 0 ? 'text-green-600' : 'text-red-600'}`}
  >
    {product.stock > 0 ? `🟢 Disponible (${product.stock} unidades)` : '🔴 Agotado'}
  </p>
</div>

<div className="flex flex-col items-center sm:flex-row gap-4">
  <div
    className="flex items-center border rounded-xl overflow-hidden bg-white"
  >
    <button
      type="button"
      onClick={() => setQuantity((prev) => Math.max(1, prev - 1))}
      className="px-4 py-3 hover:bg-gray-100 transition-colors"
    >
      -
    </button>
    <input
      min="1"
      max={product.stock}
      title="Cantidad"
      type="number"
      value={quantity}
      onChange={(e) =>
        setQuantity(Math.min(product.stock, Math.max(1, parseInt(e.target.value))))
      }
      className="w-16 text-center border-0 focus:ring-0 bg-transparent"
    />
    <button
      type="button"
      onClick={() => setQuantity((prev) => Math.min(product.stock, prev + 1))}
      className="px-4 py-3 hover:bg-gray-100 transition-colors"
    >
      +
    </button>
  </div>

  <button
    onClick={() => handleBuy(product, quantity)}
   
    className="bg-primary text-white w-[15rem] px-8 py-4 rounded-xl hover:bg-primary-dark flex items-center gap-2 text-lg font-semibold shadow-lg"
  >
    <ShoppingCart className="h-6 w-6" />
    Añadir al carrito
  </button>
</div>



<div className="pt-6 border-t border-gray-200" >
  <h2 className="text-2xl font-bold mb-4 font-poppins text-dark">
    Especificaciones técnicas
  </h2>
  <ul className="grid grid-cols-1 md:grid-cols-2 gap-4">
    {product.especificaciones?.length > 0 ? (
      product.especificaciones.map((spec, index) => (
        <li
          key={index}
          className="flex items-center gap-2 bg-gray-50 p-3 rounded-lg"
        >
          <div className="h-2 w-2 bg-primary rounded-full" />
          <span className="text-dark">{spec}</span>
        </li>
      ))
    ) : (
      <li
        className="flex items-center gap-2 bg-gray-50 p-3 rounded-lg"
      >
        <div className="h-2 w-2 bg-gray-50 rounded-full" />
        <span className="text-dark">No hay especificaciones disponibles</span>
      </li>
    )}
  </ul>
</div>


            </div>
        </div>

        {/* Sección de más información */}
        <div
          
          className="mt-12 bg-gradient-to-r from-primary/10 to-blue-50 rounded-2xl p-8 shadow-lg"
        >
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl font-bold mb-4 text-dark font-poppins">
              ¿Necesitas más información?
            </h2>
            <p className="mb-6 text-dark text-lg">
              Nuestros especialistas médicos están disponibles para asesorarte
            </p>
            <button
              className="bg-primary text-white px-8 py-4 rounded-xl hover:bg-primary-dark flex items-center gap-2 mx-auto text-lg font-semibold"
            >
              <Mail className="h-5 w-5" />
              Contactanos
              <ArrowRight className="h-5 w-5" />
            </button>
          </div>
        </div>

        <Terms/>
      </div>
    </div>
  );
};

export default ProductDetail;